import { graphql } from "relay-runtime"

export const chNutritionalCounsellingFragment = graphql`
  fragment chNutritionalCounsellingFragment on ch_NutritionalPrescription {
    id
    additionalInformation
    createdAt
    createdBy
    diagnosisCode
    healthcareProviderId
    language
    reason
    signedAt
    signedBy
    updatedAt
    updatedBy
    allergies
    conditions
    medicationIds
    nutritionalConditions
    obesityTherapy
    treatmentUnit
    sentAt
    sentBy
    concludedAt
    concludedBy
    fileMetadata {
      documentType
      extension
      lengthInKilobytes
    }
  }
`
